<template>
    <fragment>
        <ion-header>
            <ion-toolbar color="primary">
                <ion-title v-if="user" class="user-wrapper">
                    <ion-menu-toggle auto-hide="true">
                        <router-link to="/user/me">
                            <ion-avatar class="avatar ion-float-start">
                                <img
                                    :src="
                                        user.images[0]
                                            ? `${constants.assetsUri}/${user.images[0].path}`
                                            : require('../assets/imgupload-square.png')
                                    "
                                />
                            </ion-avatar>
                            <span class="ion-float-start white">{{ user.name }}</span>
                        </router-link>
                    </ion-menu-toggle>
                </ion-title>
                <ion-title v-else>{{ $t('master.menu') }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <ion-list v-if="user" class="left-menu-list">
                <ion-menu-toggle auto-hide="true">
                    <router-link to="/">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.home') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/search">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.search') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link v-if="!user.has_access" to="/plans">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.membershipUpgrade') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/messages">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.chat') }}</b>
                                <p v-if="getMessagesCount" class="unread-count ion-float-end">
                                    {{ getMessagesCount }}
                                </p>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/notifications">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.notifications') }}</b>
                                <p v-if="getNotificationsCount" class="unread-count ion-float-end">
                                    {{ getNotificationsCount }}
                                </p>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link v-if="user" to="/likers-list">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.listOfLikes') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/profile-viewers">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.profileViewers') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/profiles-viewed">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.profilesViewed') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/terms">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.terms') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/privacy-policy">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('privacyPolicy.header') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/contact">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.support') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <ion-item @click="handleLogout" button>
                        <ion-label color="secondary-shade">
                            <b>{{ $t('master.logout') }}</b>
                        </ion-label>
                    </ion-item>
                    <ion-item @click="toggleLanguage" button lines="none">
                        <ion-label color="secondary-shade">
                            <b>{{ $t('master.oppositeLanguage') }}</b>
                        </ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ion-list>
            <ion-list v-else class="left-menu-list">
                <ion-menu-toggle auto-hide="true">
                    <router-link to="/">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.home') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/search">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.search') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/terms">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.terms') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <router-link to="/contact">
                        <ion-item button>
                            <ion-label color="secondary">
                                <b>{{ $t('master.support') }}</b>
                            </ion-label>
                        </ion-item>
                    </router-link>
                    <ion-item @click="toggleLanguage" button lines="none">
                        <ion-label color="secondary-shade">
                            <b>{{ $t('master.oppositeLanguage') }}</b>
                        </ion-label>
                    </ion-item>
                    <div v-if="!user" class="ion-padding-start ion-padding-end buttons-wrapper">
                        <router-link to="/login">
                            <ion-button
                                shape="round"
                                class="login-button ion-float-start ion-no-margin ion-padding-vertical"
                                color="primary"
                                ><ion-text>{{ $t('master.login') }}</ion-text></ion-button
                            >
                        </router-link>
                        <router-link to="/register/step-1">
                            <ion-button
                                shape="round"
                                class="signup-button ion-float-end ion-no-margin ion-padding-vertical"
                                color="secondary"
                                ><ion-text>{{ $t('master.signup') }}</ion-text></ion-button
                            >
                        </router-link>
                    </div>
                </ion-menu-toggle>
            </ion-list>
        </ion-content>
    </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import { constants } from '../constants'
import AxiosController from '@/controllers/AxiosController'

export default {
    name: 'LeftMenu',
    computed: mapGetters(['user', 'lang', 'getMessagesCount', 'getNotificationsCount']),
    data() {
        return {
            constants
        }
    },
    methods: {
        handleLogout: function() {
            this.$store.dispatch('logout').then(() => this.$router.push('/login'))
        },
        toggleLanguage: function() {
            this.$i18n.locale = this.$i18n.locale == 'en' ? 'ar' : 'en'
            this.$store.dispatch('setLanguage', this.$i18n.locale)
            if (this.user) {
                AxiosController.post('update-lang', { lang: this.$i18n.locale })
            } else {
                localStorage.setItem('locale', this.$i18n.locale)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.white {
    color: #ffffff;
}
.left-menu-list {
    height: 100%;
}

> .w-50 {
    width: 50%;
}
.w-80 {
    width: 80%;
}
.w-60 {
    width: 60%;
}
.buttons-wrapper {
    position: absolute;
    bottom: 12vh;
    margin: 0;
    width: 100%;
    height: 50px;
    ion-button {
        width: 49%;
    }
    .login-button {
        height: 75px;
        --border-radius: 25px 0 0 25px;
    }

    .signup-button {
        height: 75px;
        --border-radius: 0 25px 25px 0;
    }
}

.unread-count {
    background: #ff0000;
    color: #ffffff !important;
    font-weight: 700;
    text-align: center;
    font-size: 12px;
    border-radius: 50%;
    width: 20px;
    height: 20px;
}

.user-wrapper {
    padding-left: 6px;

    span {
        position: relative;
        top: 8px;
    }

    .avatar {
        align-items: center;
        height: 100%;

        img {
            width: 30px;
            height: 30px;
        }
    }
}
</style>
